<template>
  <div class="date-field">
    <label v-if="label" for="DD" class="date-field__label">
      {{ label }}
      <span v-if="markAsOptional" class="optional-mark">(optional)</span>
    </label>
    <div class="date-field__container">
      <input
        type="number"
        min="1"
        max="31"
        v-model="DD"
        id="DD"
        ref="DD"
        placeholder="DD"
        class="date-field__input"
        @input="handleInput"
        @change="handleChange"
        :disabled="disabled"
      />
      .
      <input
        type="number"
        min="1"
        max="12"
        v-model="MM"
        id="MM"
        ref="MM"
        placeholder="MM"
        class="date-field__input"
        @input="handleInput"
        @change="handleChange"
        :disabled="disabled"
        :required="required"
      />
      .
      <input
        type="number"
        min="21"
        :max="parseFloat(new Date().toISOString().substr(2, 2)) + 10"
        v-model="YY"
        id="YY"
        ref="YY"
        placeholder="YY"
        class="date-field__input"
        @input="handleInput"
        @change="handleChange"
        :disabled="disabled"
        :required="required"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      DD: null,
      MM: null,
      YY: null
    }
  },
  props: {
    label: { type: String },
    value: { type: String },
    required: { type: Boolean, default: false },
    markAsOptional: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  created() {
    if (this.value && this.value.length === 10) {
      this.DD = this.value.substr(8, 2)
      this.MM = this.value.substr(5, 2)
      this.YY = this.value.substr(2, 4)
    } else if (this.value && this.value.length === 7) {
      this.DD = '01'
      this.MM = this.value.substr(5, 2)
      this.YY = this.value.substr(2, 4)
    }
  },
  methods: {
    handleInput(e) {
      const { value, id } = e.target
      if (value.length === 2 && id === 'DD') this.$refs.MM.focus()
      if (value.length === 2 && id === 'MM') this.$refs.YY.focus()
    },
    handleChange() {
      let { DD, MM, YY } = this
      if (DD && DD.length === 1) this.DD = '0' + DD
      if (MM && MM.length === 1) this.MM = '0' + MM
      if (DD && MM && YY) {
        this.$emit('input', `20${this.YY}-${this.MM}-${this.DD}`)
      } else if (MM && YY) {
        this.$emit('input', `20${this.YY}-${this.MM}-01`)
      } else {
        this.$emit('input', null)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../variables';

.date-field {
  margin: 0 0 1rem;

  &__container {
    padding-left: 0.75rem;

    border: 1px #ddd solid;
    border-radius: 5px;
  }

  &__label {
    display: block;
    margin: 0 0 0.75rem 0.75rem;
  }

  &__input {
    border: none;
    display: inline-block;
    height: 2.5rem;
    width: 1.5rem;
    padding: 0;

    font-family: inherit;
    font-size: inherit;
    text-align: center;

    &:focus {
      outline: none;
    }

    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }

    &::-ms-clear {
      display: none;
    }
  }
}
</style>
